export const isProd = process.env.REACT_APP_ENV === "prod";